// src/elements/Table/Table.Th.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Th = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("th", {
    className: clsx("pd:table__th", className),
    children
  });
};
var Table_Th_default = Th;
export { Table_Th_default };